/**
 * Picks the top-level fields (`keys`, never dotted paths) a sync update changed from the updated record.
 * A listed key the record no longer has (a server `$unset`) is kept as `undefined`, so `Model.update` clears it.
 */
export function pickSyncedKeys<T extends object>(record: T, keys: ReadonlyArray<string>): Partial<T> {
    return Object.fromEntries(keys.map(key => [key, (record as Record<string, unknown>)[key]])) as Partial<T>;
}
